import { Component, OnInit } from '@angular/core';
import { TopbarService } from 'src/app/core/topbar/topbar.service';

@Component({
    selector: 'app-plan',
    templateUrl: './plan.component.html',
    styleUrls: ['./plan.component.scss'],
    standalone: false
})
export class PlanComponent implements OnInit {
   

  constructor(
    private topbarService:TopbarService
  ) {
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Planificación");
   
  }

}
